<footer class="site-footer mt-auto py-2">
  <div class="container container-footer">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-1">
      <div class="footer-copy">© {{ ano }} - Feito com .NET, Angular  & café ☕</div>
      <a [routerLink]="['/login']" [queryParams]="{ retUrl: 'adm/materia' }" class="footer-admin" aria-label="Administracao">
        <i class="bi bi-person"></i>
      </a>
    </div>
  </div>
</footer>